import React from 'react';
import { BusinessPartnerCtx } from 'models/businessPartner';

export const BusinessPartnerContext = React.createContext<
  BusinessPartnerCtx | undefined
>(undefined);
